import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  width: '100%',
};

export const gridChart: SxStyle = {
  height: (p) => p.spacing(46),
};

export const boxChart: SxStyle = {
  height: '100%',
  width: '100%',
};
